import { createContext } from "react";
// Creates map cntext to share data or state to all the components that are descendants in the component tree.
const MapContext=createContext()
export default MapContext